<script>
import {OPERATORS} from "@/models/condition";
import {TreeManager} from "@/services/tree-manager";
import {useStore} from "@/helpers/store-effect";

export default {
  name: 'ConditionBranchSettings',
  template: '#condition-branch-settings-template',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const addCondition = () => {
      TreeManager.addBranchCondition(store.workflow, props.node);
    }

    const removeCondition = (condition) => {
      TreeManager.removeBranchCondition(store.workflow, props.node, condition);
    }

    return {
      properties: props.node.properties,
      operators: OPERATORS,
      addCondition,
      removeCondition
    }
  }
};
</script>
